'use strict';
module.exports = require('../../full/array/to-spliced');
